import { Flip, ToastContainerProps } from 'react-toastify';

import styles from './toast.module.scss';

const ToastConfig: ToastContainerProps = {
  position: 'bottom-left',
  autoClose: 2000,
  hideProgressBar: true,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: false,
  pauseOnHover: true,
  theme: 'colored',
  transition: Flip,
  toastClassName: styles.toast,
  limit: 3,
};

export default ToastConfig;
